/*
 * @Description:
 * @LastEditTime: 2024-02-19 15:54:04
 * @LastEditors: 何俊峰
 * @Author: 何俊峰
 * @Date: 2024-02-01 17:01:32
 */
import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import config from '@/config/index'
let base_url = config.base_url
let hasShow = config.hasShow
// create an axios instance
const service = axios.create({
  baseURL: base_url, // api 的 base_url
  timeout: 60000 // request timeout
})
// request interceptor
service.interceptors.request.use(
  config => {
      // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    config.headers['token'] =  getToken()
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
	  if(response){
		const status = response.status || 200;
		const msg = response.data.msg;
		var error_code = response.data.code;
		if(status == 200){
		  if(error_code == 0) return response
		  else{
			if(response.config.responseType !== 'blob'){
				Message({
				  message: msg,
				  type: 'error',
				  duration: 2 * 1000
				})
			}
			 return response
		  }
		}else{
		  if(status == 401){
			if(!hasShow){
				Message({
				  message: '当前会话已过期，请重新登录。',
				  type: 'error',
				  duration: 2 * 1000
				})
				setTimeout(()=>{
					store.dispatch('FedLogOut').then(() => {
						location.reload()
					})
				},2000)
				hasShow = true
			}
		  }else if(status == 500){
		  	Message({
		  	  message: '服务器错误，请稍后重试！',
		  	  type: 'error',
		  	  duration: 2 * 1000
		  	})
		  }else{
		  	Message({
		  	  message: msg || '服务异常',
		  	  type: 'error',
		  	  duration: 2 * 1000
		  	})
		  }
		}
	  }
  },
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  error => {
	  console.log(typeof error)
	  if(typeof error == 'object') error = JSON.stringify(error)
	  if(error.indexOf('401') > -1){
		if(!hasShow){
			Message({
			  message: '当前会话已过期，请重新登录。',
			  type: 'error',
			  duration: 2 * 1000
			})
			setTimeout(()=>{
				store.dispatch('FedLogOut').then(() => {
					location.reload()
				})
			},2000)
			hasShow = true
		}
	  }
	  else{
		Message({
		  message: '服务器错误，请稍后重试！',
		  type: 'error',
		  duration: 2 * 1000
		})
	  }
  },
  // error => {
  //   console.log('err' + error) // for debug
  //   Message({
  //     message: error.msg,
  //     type: 'error',
  //     duration: 5 * 1000
  //   })
  //   return Promise.reject(error)
  // }
)

export default service
